import { render, staticRenderFns } from "./emps.vue?vue&type=template&id=221426d0&scoped=true&"
import script from "./emps.vue?vue&type=script&lang=js&"
export * from "./emps.vue?vue&type=script&lang=js&"
import style0 from "./emps.vue?vue&type=style&index=0&id=221426d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221426d0",
  null
  
)

export default component.exports